<template>
  <div class="userDetail">
    <van-form label-width="120px">
      <van-field :label="$t.userList.avatar">
        <template #input>
          <van-image
            class="avatarImg"
            :src="imgUrlFilter(form.HeadImg)"
            @click="form.HeadImg ? imagePreview(imgUrlFilter(form.HeadImg)) : false"
          >
            <template v-slot:error>
              <img
                class="userImg"
                src="~assets/img/userManage/img_logo@2x.png" /></template
          ></van-image>
        </template>
      </van-field>

      <van-field v-model="form.UserName" :label="$t.userList.username" readonly />

      <van-field v-model="form.PhoneNumber" :label="$t.userList.phone" readonly />

      <van-field v-model="form.Email" :label="$t.userList.email" readonly />

      <van-field
        v-model="form.ParentUserName"
        :label="$t.userList.parentUserName"
        readonly
      />
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "userDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      userId: "",
      form: {
        HeadImg: "",
        UserName: "",
        PhoneNumber: "",
        Email: "",
        ParentUserName: "",
      },
    };
  },
  created() {
    const { UserId } = this.$route.query;
    this.userId = UserId;
    this.getUserDetail();
  },
  methods: {
    getUserDetail() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          UserId: this.userId,
        };
        this.$api.systemManagement
          .getUserDetail(param)
          .then((res) => {
            this.form = res.data;
            this.$commonMethod.fieldRefresh(".userDetail");
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.userDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }

  .van-cell::after {
    border: none !important;
  }

  .avatarImg {
    width: 80px;
    height: 80px;

    .userImg {
      width: 80px;
      height: 80px;
      object-fit: cover;
      border-radius: 100%;
    }

    ::v-deep .van-image__error {
      border-radius: 100%;
      position: block;
    }

    ::v-deep .van-image__img {
      object-fit: cover;
      border-radius: 100px;
    }
  }
}
</style>
